import { requests } from "../../../../api/agent"

export default {
	create        : (params) => requests.post('/reOrgType/create', params),
	update        : (params) => requests.post('/reOrgType/update', params),
	delete        : (params) => requests.getWithParams('/reOrgType/delete', params),
	restore       : (params) => requests.getWithParams('/reOrgType/restore', params),
	getPaged      : (params) => requests.getWithParams('/reOrgType/getPaged', params),
	getPagedAll   : (params) => requests.getWithParams('/reOrgType/getPagedAll', params),
	getPagedAudit : (params) => requests.getWithParams('/reOrgType/getPagedAudit', params),
	getList       : (params) => requests.getWithParams('/reOrgType/getList', params)
}